<template>
  <div class="outer__content text-center">
      <div><img style="max-width: 500px; width: 100%; margin:0 auto;" src="@/assets/bkk-fogas-logo.svg" alt="BKK telebusz"></div>
      <CsobajInfoBox/>
      <h1 class="h1">{{$t($route.meta.title)}}</h1>

      <div class="outer__inner">
          <router-view/>
      </div>

      <div class="row align-items-center justify-content-center pt-5">
          <div class="col-auto"><a href="https://www.interreg-central.eu/smacker" target="_blank"><img style="width:110px" src="@/assets/interreg-logo.png" alt="Interreg Central Europe" /></a></div>
          <div class="col-auto"><a href="https://bkk.hu" target="_blank"><img src="@/assets/bkk-logo.svg" alt="BKK" /></a></div>
      </div>

  </div>
</template>
<script>
import CsobajInfoBox from '@/components/CsobajInfoBox.vue';
export default {
  name: 'OuterLayout',
  components: {
    CsobajInfoBox
  }
}
</script>
<style lang="scss" src="@/assets/scss/common.scss"></style>
<style lang="scss" src="@/assets/scss/outer.scss" scoped></style>

